"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../typography");
var Grid_1 = __importDefault(require("../../basics/Grid"));
var Link_1 = __importDefault(require("../Link"));
var VerticalSpacer_1 = __importDefault(require("../../utils/VerticalSpacer"));
var HorizontalSpacer_1 = __importDefault(require("../../utils/HorizontalSpacer"));
var Icon_1 = __importDefault(require("../../basics/Icon"));
var Pill_1 = __importDefault(require("../../misc/Pill"));
var styles_1 = require("./styles");
var GRID_1_ROW_GAP = { small: 24, medium: 48, large: 48 };
var GRID_1_CELL_SPAN_1 = {
    small: 4,
    medium: 4,
    large: 6,
    xlarge: 6,
};
var GRID_1_CELL_SPAN_1b = 'full';
var GRID_1_CELL_SPAN_2 = {
    small: 4,
    medium: 4,
    large: 6,
    xlarge: 6,
};
var GRID_1_CELL_SPAN_3 = {
    small: 2,
    medium: 4,
    large: 3,
    xlarge: 3,
};
var VS_1 = { small: 8, medium: 16, large: 16 };
var HS_1 = { small: 16, medium: 16, large: 24 };
var HS_2 = { small: 4, medium: 6, large: 8 };
var SiteFooter = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.socialLinks, socialLinks = _c === void 0 ? [] : _c, _d = _a.bottomLinks, bottomLinks = _d === void 0 ? [] : _d, children = _a.children, commonProps = __rest(_a, ["items", "socialLinks", "bottomLinks", "children"]);
    var currentYear = react_1.default.useMemo(function () { return new Date().getFullYear(); }, []);
    var content = children ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default.Cell, { span: GRID_1_CELL_SPAN_1 }, children),
        react_1.default.createElement(Grid_1.default.Cell, { span: GRID_1_CELL_SPAN_2 },
            react_1.default.createElement(styles_1.SocialWrapper, null, socialLinks.map(function (socialLink, i) { return (react_1.default.createElement(Link_1.default, { key: i, href: socialLink.href, color: "WHITE", hoverColor: "GREY_50", isExternal: true, ariaLabel: "Open " + socialLink },
                react_1.default.createElement(Icon_1.default, { name: socialLink.name }))); }))))) : (react_1.default.createElement(Grid_1.default.Cell, { span: GRID_1_CELL_SPAN_1b },
        react_1.default.createElement(styles_1.SocialWrapper, null, socialLinks.map(function (socialLink, i) { return (react_1.default.createElement(Link_1.default, { key: i, href: socialLink.href, color: "WHITE", hoverColor: "GREY_50", isExternal: true, ariaLabel: "Open " + socialLink },
            react_1.default.createElement(Icon_1.default, { name: socialLink.name }))); }))));
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "SiteFooter" }, commonProps),
        react_1.default.createElement(styles_1.Main, null,
            react_1.default.createElement(Grid_1.default, { rowGap: GRID_1_ROW_GAP },
                content,
                items.map(function (item, i) { return (react_1.default.createElement(Grid_1.default.Cell, { key: i, span: GRID_1_CELL_SPAN_3 },
                    react_1.default.createElement(VerticalSpacer_1.default, { amount: VS_1 },
                        react_1.default.createElement(typography_1.Heading, { level: "4", color: "WHITE" }, item.display),
                        react_1.default.createElement(styles_1.Items, null, (item.items || []).map(function (subItem, subItemIndex) { return (react_1.default.createElement(HorizontalSpacer_1.default, { amount: HS_2, key: subItemIndex },
                            react_1.default.createElement(typography_1.Body, { level: "3", inline: true },
                                react_1.default.createElement(Link_1.default, { href: subItem.href, isExternal: subItem.isExternal, color: "WHITE", hoverColor: "GREY_50" }, subItem.display)),
                            subItem.isNew && react_1.default.createElement(Pill_1.default, null, "New!"))); }))))); }))),
        react_1.default.createElement(Grid_1.default, null,
            react_1.default.createElement(Grid_1.default.Cell, { span: "full" },
                react_1.default.createElement(styles_1.Bottom, null,
                    react_1.default.createElement(typography_1.Body, { level: "3", color: "GREY_60", inline: true },
                        "\u00A9",
                        currentYear,
                        " SuperHi, Inc., a proudly remote team."),
                    react_1.default.createElement(HorizontalSpacer_1.default, { amount: HS_1, wrap: true }, bottomLinks.map(function (bottomLink, i) { return (react_1.default.createElement(typography_1.Body, { key: i, level: "3", inline: true },
                        react_1.default.createElement(Link_1.default, { href: bottomLink.href, isExternal: bottomLink.isExternal, color: "GREY_60", hoverColor: "GREY_50" }, bottomLink.display))); })))))));
};
exports.default = SiteFooter;
